






















import { Vue, Component } from "vue-property-decorator";
import { Empty } from "vant";

@Component({
  components: {
    [Empty.name]: Empty,
  },
})
export default class extends Vue {
  //data

  back() {
    history.back();
  }
}
